<template>
  <div>
    <DataTable :url="api.ACTIONS.BONUS_PACKAGE"
               :actionsExtraMain="actionsExtraMain"
               :enable-delete="false"
               :enable-edit="false"
               :fields-hidden-add="['created_at','id']"
               :fields-extra-add="fieldsExtraAdd"
               :input-types-add="{
                            slice: {items: ['DAILY', 'WEEKLY', 'MONTHLY', 'EVER'],clearable: true},
                            visibility: {items: ['ALL', 'CUSTOM', 'SATISFY'], clearable: true},
                            prise: {items: ['MAX', 'SATISFIED'], clearable: true},
                            penalty_type: {items: ['FIXED', 'REVENUE_PERCENTAGE'], clearable: true},
                            captain_expiration_from: {items: ['BONUS_JOIN_DATE', 'MONACO_JOIN_DATE', 'CUSTOM', 'FIRST_RIDE'], clearable: true},
                   }"
               :title="$t('settings.index.conditionalBonus')"/>
  </div>
</template>

<script>

import DataTable from "@/components/monaco/DataTable";

export default {
  components: {DataTable},
  name: "bonus-packages",
  title() {
    return this.$t('settings.index.title');
  },
  data() {
    return {
      slice: ['DAILY', 'WEEKLY', 'MONTHLY', 'EVER'],
    }
  },
  computed: {
    fieldsExtraAdd() {
      return {
        name: 'v-text-field',
        details: 'v-text-field',
        level_id: 'choose-level',
        slice: 'v-select',
        visibility: 'v-select',
        achievable_times: 'v-text-field',
        prise: 'v-select',
        satisfy_all: 'v-checkbox',
        join_limit: 'v-text-field',
        start_date: 'choose-date',
        end_date: 'choose-date',
        min_rating: 'v-text-field',
        min_paid_payments: 'v-text-field',
        min_bookings: 'v-text-field',
        max_join_date: 'choose-date',
        last_payment_after: 'choose-date',
        penalty_type: 'v-select',
        penalty_value: 'v-text-field',
        captain_expiration_from: 'v-select',
        captain_expiration_in_days: 'v-text-field',
      };
    },
    actionsExtraMain() {
      return {
        prices: {
          icon: 'supervisor_account',
          extras: {
            color: 'gray'
          },
          action: (item) =>
              this.$router.push({
                name: "Bonus Package Details",
                params: {"id": item.id}
              })
        },
        bonuses: {
          icon: 'attach_money',
          extras: {
            medium: true
          },
          action: (item) =>
              this.$router.push({
                name: "Bonuses",
                params: {"id": item.id}
              })
        }
      }
    },
  }
}
</script>
